export default "__VITE_ASSET__Bec46$gv__"